import { useMutation } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TokenResponse, useGoogleLogin } from '@react-oauth/google';
import CSS from 'csstype';
import { motion } from 'framer-motion';
import {
    LoginGoogle,
    LoginGoogleVariables
} from 'libs/graphql/mutation/access/__generated__/LoginGoogle';
import { LOGIN_GOOGLE_MUTATION } from 'libs/graphql/mutation/access/accessMutation';
import { conditionalScaleAnimation } from 'libs/styles/animations';
import { EFonts, EHovers } from 'libs/styles/styling';
import { EToastType } from 'libs/types/site/IClient';
import { userMessage } from 'libs/utils/logic/ui/uiLogic';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router';
import { GlobalContext } from 'session/state/context';
import { setLoggedUser } from 'session/state/user/userActions';
import Config from 'static/config/coreConfig';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

export interface IProps {
    children?: React.ReactNode;
    callback?: () => void;

    style?: CSS.Properties;
    className?: string;
}

export const GoogleAccess = (props: IProps): JSX.Element => {
    const { dispatch } = useContext(GlobalContext);
    const [loginMutation] = useMutation<LoginGoogle, LoginGoogleVariables>(LOGIN_GOOGLE_MUTATION);
    const navigate = useNavigate();

    const redirectUri = `${location.protocol}//${location.host}/login`;

    console.log('Config.GoogleClientId', Config.GoogleClientId, redirectUri);

    const login = useGoogleLogin({
        onSuccess: googleSuccess,
        onError: googleError,
        ux_mode: 'redirect',
        redirect_uri: redirectUri
    });

    function googleSuccess(response: unknown): void {
        const token = (response as TokenResponse).access_token;
        console.log('TOKEN', token);
        if (!token) {
            googleError(null);
            return;
        }
        const variables = {
            token,
            userId: null
        };
        loginMutation({
            variables
        })
            .then((userLogin) => {
                console.log('USERLOGIN', userLogin);
                if (!userLogin) {
                    userMessage(EToastType.ERROR, 'User not found');
                } else {
                    const user = userLogin.data.loginUserByGoogle.user;
                    const tokenType = userLogin.data.loginUserByGoogle.tokenType;
                    const accessToken = userLogin.data.loginUserByGoogle.accessToken;
                    if (props.callback) {
                        props.callback();
                        dispatch(setLoggedUser(user, tokenType, accessToken));
                    } else {
                        userMessage(EToastType.SUCCESS, Localization.WELCOME);
                        dispatch(setLoggedUser(user, tokenType, accessToken));
                        navigate('/admin');
                    }
                }
            })
            .catch((error) => {
                console.log('Catch', error);
            });
    }

    function googleError(error: unknown) {
        console.log('ERROR', error);
    }

    return (
        <S_GoogleAccess className={props.className} style={props.style}>
            <motion.div {...conditionalScaleAnimation(true, 1.05, 0.9)}>
                <S_ActionButton onClick={login}>
                    <S_Icon icon={['fab', 'google']} />
                    <S_Text>Google</S_Text>
                </S_ActionButton>
            </motion.div>
        </S_GoogleAccess>
    );
};

const S_GoogleAccess = styled.div``;

const S_ActionButton = styled.div`
    border-radius: 7px;
    background: linear-gradient(225deg, #b04123 0%, #cc573b 100%);
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.03);
    height: 45px;
    padding: 10px 20px;
    width: 150px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.03), ${EHovers.LIGHT1};
    }
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 25px;
    color: white;
    margin: 0 15px 0 0;
`;

const S_Text = styled.span`
    color: white;
    font-size: 14px;
    font-family: ${EFonts.Medium};
`;
